const $ = require('cash-dom');
const Page = require('./page');
const Ajax = require('./ajax');

const Feedback = {
    triggerNoteError: function (show) {
        if (show) {
            $('#note_error').removeClass('hidden');
            $('.feedback-note').addClass('error');
        } else {
            $('#note_error').addClass('hidden');
            $('.feedback-note').removeClass('error');
        }
    },
    initScores: function () {
        let self = this;

        const GOOD_SCORE = 8;
        const $feedbackScore = $('.feedback [name="feedback_score"]');
        const feedbackScoreValue = $feedbackScore.length ? parseFloat($feedbackScore.val()) : null;

        if (feedbackScoreValue >= GOOD_SCORE) {
            _makeScoreNotEditable();
            return;
        }

        $(document).on('change', '.feedback [name="feedback_score"]', function () {
            let feedbackContainerEl = $(this).closest('.feedback'),
                score = parseFloat($(this).val()),
                postId = feedbackContainerEl.attr('data-post-id');

            Page.startLoad('feedback', feedbackContainerEl);
            $('.thanks-for-feedback').addClass('hidden');
            $('.feedback-note-holder').addClass('hidden');
            Ajax.post(ajaxurl, {
                action: 'post_feedback_score',
                post_id: postId,
                score: score
            }, function (response) {
                if (response.success) {
                    if (response.thank_you) {
                        $('.thanks-for-feedback').removeClass('hidden');
                    }
                    if (response.show_note) {
                        $('.feedback-note-holder').removeClass('hidden');
                    } else {
                        $('.feedback-note-holder').addClass('hidden');
                    }

                    if (response.share) {
                        $($('.facebook-share.sharrre').get(0)).trigger("click");
                    }

                    if (response.feedbackResult) {
                        $('#feedback-result').html(response.feedbackResult);
                    }

                    if (score >= GOOD_SCORE) {
                        _makeScoreNotEditable();
                    }
                }
            }, 'json').done(function () {
                Page.finishLoad('feedback');
            });
        });

        function _makeScoreNotEditable() {
            $('.stars-rating.feedback-score').removeClass('editable-rating');
        }
    },
    initNote: function () {
        let self = this;

        $('.feedback .submit-note').on('click', function () {
            let postId = $(this).closest('.feedback').attr('data-post-id'),
                note = $('.feedback-note').val();

            $('.thanks-for-feedback').addClass('hidden');

            if (note.length) {
                self.triggerNoteError();
                Page.startLoad('feedback', $('.feedback-note-holder'));

                Ajax.post(ajaxurl, {
                    action: 'post_feedback_note',
                    post_id: postId,
                    note: note
                }, function (response) {
                    if (response.success) {
                        $('.thanks-for-feedback').removeClass('hidden');
                        $('.feedback-note-holder').remove();

                        if (response.feedbackResult) {
                            $('#feedback-result').html(response.feedbackResult);
                        }
                    }
                }, 'json').done(function () {
                    Page.finishLoad('feedback');
                });
            } else {
                self.triggerNoteError(true);
            }

            return false;
        });
    },
    init: function () {
        this.initScores();
        this.initNote();
    }
};

module.exports = Feedback;
